import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { EnvironmentBannerComponent } from '@shared/components';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, EnvironmentBannerComponent],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'rocket-capture';
}
